// Formatting and derivation shared by the send-log pages and the export layer.
//
// These lived inside SendHistoryPage / CourseSendHistoryPage, which meant
// exportData.js - the module that describes what an export contains - imported
// two React components to get at five pure functions. Harmless in the browser,
// fatal for reuse: the scheduled-delivery renderer runs in Node and cannot pull
// React and MUI in behind a date formatter.
//
// Nothing here touches the DOM or React, so both the pages and a server-side
// renderer can use it. The pages re-export their previous names so existing
// imports keep working.

// Badge vocabulary for a simulation send. Colours are CSS variables resolved by
// the page; the export layer only reads `label`.
export const STATUS_META = {
    clicked:     { label: 'Clicked',           bg: 'var(--amber-bg)', text: 'var(--amber-text)', border: 'rgba(255,202,40,.3)',   dot: '#FFCA28' },
    clicked_2nd: { label: '2nd Stage Clicked', bg: 'var(--red-bg)',   text: 'var(--red-text)',   border: 'rgba(255,82,82,.25)',   dot: '#FF5252' },
    reported:    { label: 'Reported',          bg: 'var(--green-bg)', text: 'var(--green-text)', border: 'rgba(102,187,106,.25)', dot: '#66BB6A' },
    no_click:    { label: 'No Engagement',     bg: 'action.hover',    text: 'text.secondary',    border: 'divider',               dot: 'text.disabled' },
};

// Dropdown order mirrors the table's badge vocabulary exactly.
export const STATUS_OPTIONS = ['clicked', 'clicked_2nd', 'reported', 'no_click'];

// API timestamps are UTC without a zone suffix; render them in the viewer's
// local time zone, with the time of day.
export function fmtLocal(iso) {
    if (!iso) return '';
    const s = String(iso);
    const ms = Date.parse(/Z$|[+-]\d\d:?\d\d$/.test(s) ? s : s + 'Z');
    if (Number.isNaN(ms)) return '';
    return new Date(ms).toLocaleString(undefined, { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function courseScore(e) {
    if (e.correctAnswers == null || !e.totalQuestions) return null;
    return Math.round((e.correctAnswers / e.totalQuestions) * 100);
}

export function courseStatus(e) {
    return e.dateCompleted ? 'Completed' : 'Outstanding';
}

// Derived outcome covering failures and retries. Null for a plain outstanding
// send with no attempt yet (renders as a dash and matches no outcome filter).
export function courseOutcome(e) {
    const score = courseScore(e);
    const completed = !!e.dateCompleted;
    if (completed && score != null) return score >= 80 ? 'Passed' : 'Failed';
    if (!completed && score != null) return 'Retry';
    if (completed) return 'Expired';
    return null;
}
